"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPlayer = VideoPlayer;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledVideoPlayer = require("./styled-video-player");
var _excluded = ["className", "dataAnalyticsId", "dataTestId", "description", "onPauseCallback", "onPlayCallback", "poster", "preload", "ratio", "sources", "title", "titleTag", "tracks", "videoOptions"],
  _excluded2 = ["src", "type"],
  _excluded3 = ["src", "type", "label"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var displayName = 'VideoPlayer';
var defaultProps = {
  className: 'fuse-video-player',
  dataAnalyticsId: undefined,
  dataTestId: 'fuse-video-player-test-id',
  description: undefined,
  onPauseCallback: undefined,
  onPlayCallback: undefined,
  poster: '',
  preload: 'none',
  ratio: '16:9',
  title: undefined,
  titleTag: 'h2',
  tracks: undefined,
  videoOptions: undefined
};
var propTypes = {
  className: _propTypes["default"].string,
  dataAnalyticsId: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  description: _propTypes["default"].string,
  onPauseCallback: _propTypes["default"].func,
  onPlayCallback: _propTypes["default"].func,
  poster: _propTypes["default"].string,
  preload: _propTypes["default"].oneOf(['none', 'auto', 'metadata']),
  ratio: _propTypes["default"].oneOf(['16:9', '1:1', '4:3', '5:4', '3:4']),
  sources: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    src: _propTypes["default"].string.isRequired,
    type: _propTypes["default"].string.isRequired
  })).isRequired,
  title: _propTypes["default"].string,
  titleTag: _propTypes["default"].string,
  tracks: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    src: _propTypes["default"].string.isRequired,
    type: _propTypes["default"].oneOf(['captions', 'subtitles']).isRequired,
    label: _propTypes["default"].string.isRequired
  })),
  videoOptions: _propTypes["default"].shape({})
};
function VideoPlayer(_ref) {
  var className = _ref.className,
    dataAnalyticsId = _ref.dataAnalyticsId,
    dataTestId = _ref.dataTestId,
    description = _ref.description,
    onPauseCallback = _ref.onPauseCallback,
    onPlayCallback = _ref.onPlayCallback,
    poster = _ref.poster,
    preload = _ref.preload,
    ratio = _ref.ratio,
    sources = _ref.sources,
    title = _ref.title,
    titleTag = _ref.titleTag,
    tracks = _ref.tracks,
    videoOptions = _ref.videoOptions,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    initialClick = _useState2[0],
    setInitialClick = _useState2[1];
  var videoRef = (0, _react.useRef)();
  var onPauseHandler = (0, _react.useCallback)(function (e, ref) {
    if (typeof onPauseCallback === 'function') onPauseCallback(e, ref);
  }, [onPauseCallback]);
  var onPlayHandler = (0, _react.useCallback)(function (e, ref) {
    if (typeof onPlayCallback === 'function') onPlayCallback(e, ref);
  }, [onPlayCallback]);
  var onClickHandler = function onClickHandler() {
    videoRef.current.play();
    setInitialClick(true);
  };
  var hasText = title || description;
  return /*#__PURE__*/_react["default"].createElement(_styledVideoPlayer.StyledVideoPlayer, _extends({
    className: className,
    "data-testid": dataTestId
  }, props), hasText && /*#__PURE__*/_react["default"].createElement(_styledVideoPlayer.StyledTextWrapper, null, title && /*#__PURE__*/_react["default"].createElement(_styledVideoPlayer.StyledTitle, {
    size: {
      xxs: '2',
      m: '3'
    },
    tag: titleTag,
    type: "heading"
  }, title), description && /*#__PURE__*/_react["default"].createElement(_styledVideoPlayer.StyledDescription, {
    size: "1",
    type: "paragraph"
  }, description)), /*#__PURE__*/_react["default"].createElement(_styledVideoPlayer.StyledVideo, _extends({
    ref: videoRef,
    "data-analyticsid": dataAnalyticsId,
    controls: true,
    crossOrigin: "anonymous",
    poster: poster,
    preload: preload,
    ratio: ratio,
    onClick: function onClick() {
      return !initialClick && onClickHandler();
    },
    onPause: function onPause(e) {
      return onPauseHandler(e, videoRef);
    },
    onPlay: function onPlay(e) {
      return onPlayHandler(e, videoRef);
    }
  }, videoOptions), sources.map(function (_ref2) {
    var src = _ref2.src,
      type = _ref2.type,
      source = _objectWithoutProperties(_ref2, _excluded2);
    return /*#__PURE__*/_react["default"].createElement("source", _extends({
      key: src,
      className: "fuse-video-player__source",
      src: src,
      type: "video/".concat(type)
    }, source));
  }), tracks && tracks.map(function (_ref3) {
    var src = _ref3.src,
      type = _ref3.type,
      label = _ref3.label,
      track = _objectWithoutProperties(_ref3, _excluded3);
    return /*#__PURE__*/_react["default"].createElement("track", _extends({
      key: src,
      className: "fuse-video-player__track",
      src: src,
      kind: type,
      label: label
    }, track));
  }), "Your browser does not support the video tag."));
}
VideoPlayer.displayName = displayName;
VideoPlayer.propTypes = propTypes;
VideoPlayer.defaultProps = defaultProps;
var _default = exports["default"] = VideoPlayer;